import { render, staticRenderFns } from "./edit-rates.vue?vue&type=template&id=0520f28b"
import script from "./edit-rates.vue?vue&type=script&lang=js"
export * from "./edit-rates.vue?vue&type=script&lang=js"
import style0 from "./edit-rates.vue?vue&type=style&index=0&id=0520f28b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports